import { Container, Grid } from '@mui/material';
import { useContactContext } from '../providers/ContactProvider';
import { QuickConnectActionButton } from './QuickConnectActionButton';
import { QuickConnectColdTransferButton } from './QuickConnectColdTransferButton';

interface IQuickConnectControlsProps {
  selectedQc: string;
  setSelectedQc: (state: string) => void;
}
export const QuickConnectControls = ({
  selectedQc,
  setSelectedQc,
}: IQuickConnectControlsProps) => {
  return (
    <Container
      sx={{
        height: '5rem',
        marginTop: '1rem',
      }}
    >
      <Grid
        container
        height='100%'
        flexDirection='row'
        justifyContent='end'
        alignItems='center'
        wrap='nowrap'
        spacing={2}
      >
        <Grid item>
          <QuickConnectActionButton
            selectedQc={selectedQc}
            setSelectedQc={setSelectedQc}
          />
        </Grid>
      </Grid>
    </Container>
  );
};
